export default __webpack_public_path__ + "static/media/img8.437aa959.jpg";